import React from "react";
import { Outlet } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import Newheader from "../Newheader";
import Newfooter from "../Newfooter";

const StudentQuizLayout = () => {
  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Header */}
      <Newheader />

      {/* Main content */}
      <main
        className="flex-grow-1"
        style={{
          position: "relative",
          background: "linear-gradient(to bottom, #ffffff 40%, #B9D9F0 100%)",
        }}
      >
        <div
          style={{
            content: "''",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "50%",
            opacity: 0.15,
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 0,
          }}
        />
        <div
          className="overflow-auto w-100 py-3 px-5"
          style={{
            zIndex: 1,
            position: "relative",
          }}
        >
          <Outlet />
        </div>
      </main>

      {/* Footer stays below all content */}
      <Newfooter />
    </div>
  );
};

export default StudentQuizLayout;
